import { LegendWithOneLineCheckboxFlex } from "@similarweb/ui-components";
import { Box } from "@similarweb/ui-components/foundations";

import { Legends } from "app/components/React/Legends/Legends";
import type { ILegendItems } from "app/components/React/Legends/legendsTypes";

interface IGraphLegendProps {
    legendItems: ILegendItems;
    onLegendClick: (legendItem: { name: string }) => void;
}

export const GraphLegend = ({ legendItems, onLegendClick }: IGraphLegendProps) => {
    if (!legendItems || legendItems.length <= 0) {
        return null;
    }

    return (
        <Box padding="24px 0 16px 0">
            <Legends
                legendComponent={LegendWithOneLineCheckboxFlex}
                legendItems={legendItems}
                legendsGap="16px"
                toggleSeries={onLegendClick}
            />
        </Box>
    );
};
